import { render } from "./Anchor.vue?vue&type=template&id=12fc125a&scoped=true"
import script from "./Anchor.vue?vue&type=script&lang=js"
export * from "./Anchor.vue?vue&type=script&lang=js"

import "./Anchor.vue?vue&type=style&index=0&id=12fc125a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-12fc125a"

export default script